import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalFooter,
  ModalHeader, Grid, GridItem, useStyleConfig,
} from '@chakra-ui/react';
import ModalQuestion from './ModalQuestion';
import { handleDone } from './utils';

const BulletModal = ({ jobSeekerData, props, option }) => {
  const stateProps = props.stateProps;

  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  //Bullet Button needs to be styled in styles/partials/elements/BulletBankStyles
  const styles = stateProps.proTipStyles;
  //the above is a placeholder
  let opened = false;
  if (
    stateProps.isBulletOpen &&
    option.key === stateProps.bulletData.bulletModal.key
  ) {
    opened = true;
  }
  if (
    opened &&
    typeof option.origMatches !== 'undefined' &&
    option.origMatches.length > 0
  ) {

    return (
      <>
        {Object.keys(stateProps.bulletData.bulletModal).length > 0 && (
          <Modal isOpen={stateProps.isBulletOpen} onClose={stateProps.onBulletClose}>
            <ModalOverlay bg="blackAlpha.300" />
            <ModalContent sx={{ ...styles.modalContent }}>
              <ModalHeader
                sx={{ ...styles.modalContent.modalHeader }}
              ></ModalHeader>
              <ModalCloseButton sx={{ ...styles.modalCloseButton }} />
                <ModalQuestion props={props} jobSeekerData={jobSeekerData} />
              <ModalFooter sx={{ ...styles.modalFooter }}>
                <Grid >
                  <GridItem>
                    <Button
                      sx={{ ...buttonStyles.primary }}
                      onClick={e => handleDone(e, stateProps, jobSeekerData)}
                    >
                      Done
                    </Button>
                  </GridItem>
                </Grid>
              </ModalFooter>
            </ModalContent>
          </Modal>
        )}
      </>
    );
  } else {
    return null;
  }
};

export default BulletModal;
